import { HubConnectionBuilder, HttpTransportType } from "@microsoft/signalr";

import { hubConnectionSuccess } from "../../ducks/signalr";

const token = () => sessionStorage.getItem("eRecuperadorJwt");

export default (id) => {
  const route = `${process.env.REACT_APP_SIGNALR_URL}/${id}`;

  return (dispatch) => {
    const connection = new HubConnectionBuilder()
      .withUrl(route, {
        transport: HttpTransportType.WebSockets | HttpTransportType.LongPolling,
        "content-type": "application/json",
        accessTokenFactory: token,
      })
      .withAutomaticReconnect()
      .build();

    connection.start().catch((err) => console.log(err.toString()));

    dispatch({ type: hubConnectionSuccess, payload: connection });
  };
};
